export interface Utilisateur {
  id?: string;
  idCognito?: string;
  type?: Utilisateur.Type;
  login: string;
  email: string;
  isExternalEmail: boolean;
  nom: string;
  prenom: string;
  phone?: string;
  codeValidationExpiration?: string;
  idOrganisme?: string;
  statut?: string;
  codeValidation?: string;
  gestionnaireId?: string;
  dateCreation?: string;
  dateModification?: string;
  dateConnexion?: string;
}

export interface UserLight {
  email: string;
  lastName: string;
  firstName: string;
  organizationCode: string;
  type?: UserLight.Type;
  login?: string;
}

export namespace Utilisateur {
  export enum Type {
    ID_NOT = 'ID_NOT',
    AUTRE = 'AUTRE',
    CB = 'CB',
  }

  export interface CanEdit {
    nom: boolean;
    prenom: boolean;
    email: boolean;
    phone: boolean;
  }
}

export namespace UserLight {
  export enum Type {
    CB = 'CB',
    AUTRE = 'AUTRE',
  }
}
